module.exports = {
  getStorage () {
    if (! window.localStorage.bulldesk) {
      window.localStorage.bulldesk = '{}';
    }
    return JSON.parse(window.localStorage.bulldesk);
  },

  put (key, value) {
    const storage = this.getStorage();
    storage[key] = value;
    window.localStorage.bulldesk = JSON.stringify(storage);
  },

  get (key) {
    const storage = this.getStorage();
    const config = storage[key];

    if (typeof config === 'undefined') {
      return false;
    }

    return config;
  },
};
